export const removeSrcAttributeValuesFromHtml = (value?: string): string => {
  if (!value || typeof value !== 'string') {
    return value ?? '';
  }

  return value.replace(/\bsrc\s*=\s*(['"])[\s\S]*?\1/gi, 'src=""');
};

export const getContentLengthForValidation = (value?: string): number => {
  if (!value || typeof value !== 'string') {
    return 0;
  }

  return removeSrcAttributeValuesFromHtml(value).length;
};
